const FEATURES = [
  { icon: '/assets/icons/access.svg', text: "See every family's contact info at a glance" },
  { icon: '/assets/icons/calendar.svg', text: "Preload your year's calendar and notify families on time" },
  { icon: '/assets/icons/link.svg', text: 'Share consent forms and sign-up links in one place' },
  { icon: '/assets/icons/mail.svg', text: 'Draft clear class emails from your calendar' },
  { icon: '/assets/icons/donation.svg', text: 'Track donations, expenses, and receipts' },
];

export default function AuthLayout({ children }) {
  return (
    <div className="auth-layout active">
      {/* phones lead with the brand, then the form, then the pitch below it —
          the panel's own logo is hidden at that width */}
      <div className="auth-mobile-bar">
        <div className="mark">R</div>
        <div className="name">
          Room Parent<small>Portal</small>
        </div>
      </div>
      <div className="auth-left">
        <div className="auth-left-logo">
          <div className="mark">R</div>
          <div className="name">
            RoomParent.com<small>Portal</small>
          </div>
        </div>
        <div className="auth-left-body">
          <h2>Everything you need to run your class.</h2>
          <p>One place for your class calendar, parent emails, links, and fundraising — no more spreadsheets.</p>
          <div className="auth-left-features">
            {FEATURES.map((f) => (
              <div className="auth-feature" key={f.icon}>
                <span className="ic"><img src={f.icon} alt="" /></span>
                <span>{f.text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="auth-right">
        <div className="auth-box">{children}</div>
      </div>
    </div>
  );
}
